import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-caption text-medium-emphasis ml-3"
}
const _hoisted_2 = {
  key: 2,
  class: "text-caption text-medium-emphasis ml-3"
}
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_4 = { class: "text-overline mb-2" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 3,
  class: "text-center text-medium-emphasis pa-8"
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import FormattingCard from '@/components/cards/FormattingCard.vue'
import FactoryStepRunCard from '@/components/factories/FactoryStepRunCard.vue'
import type { FactoryRunDisplay, FactoryStepRunRecord } from '@/types/factories'
import { getDashboardTabPath } from '@/router/dashboardTabs'


export default /*@__PURE__*/_defineComponent({
  __name: 'FactoryRunPanel',
  props: {
    run: {}
  },
  emits: ["pause", "resume", "cancel"],
  setup(__props: any) {

const props = __props



const store = useStore()
const router = useRouter()

async function openWorkflowRun(stepRun: FactoryStepRunRecord) {
  if (!stepRun.workflowRunId || !stepRun.invoked.workflowConfigId) return
  await store.dispatch('setPendingWorkflowRun', {
    workflowId: stepRun.invoked.workflowConfigId,
    runId: stepRun.workflowRunId
  })
  await store.dispatch('setTab', 'workflows')
  if (router.currentRoute.value.path !== getDashboardTabPath('workflows')) {
    await router.push(getDashboardTabPath('workflows'))
  }
}

async function openChatSession(stepRun: FactoryStepRunRecord) {
  if (!stepRun.chatId) return
  let hydrated = store.getters.getHydratedFactoryStepRun?.(stepRun.stepRunId)
  if (!hydrated) {
    await store.dispatch('fetchHydratedFactoryStepRun', { runId: stepRun.runId, stepRunId: stepRun.stepRunId })
    hydrated = store.getters.getHydratedFactoryStepRun?.(stepRun.stepRunId)
  }
  const chatSession = hydrated?.chatSession
  if (!chatSession) return
  await store.dispatch('setPendingChatAgent', {
    slug: chatSession.agentSlug,
    ownerUsername: chatSession.agentUsername,
    chatId: chatSession.id
  })
  await store.dispatch('setTab', 'chat')
  if (router.currentRoute.value.path !== getDashboardTabPath('chat')) {
    await router.push(getDashboardTabPath('chat'))
  }
}

const headerIcon = computed(() => {
  switch (props.run.status) {
    case 'idle': return 'mdi-circle-outline'
    case 'running': return 'mdi-loading mdi-spin'
    case 'paused': return 'mdi-pause-circle'
    case 'completed': return 'mdi-check-circle'
    case 'cancelled': return 'mdi-cancel'
    case 'error': return 'mdi-alert-circle'
    default: return 'mdi-circle-outline'
  }
})

const headerColor = computed(() => {
  switch (props.run.status) {
    case 'idle': return 'grey'
    case 'running': return 'primary'
    case 'paused': return 'warning'
    case 'completed': return 'success'
    case 'cancelled': return 'warning'
    case 'error': return 'error'
    default: return 'grey'
  }
})

const statusTimestampLabel = computed(() => {
  if (!props.run.startedAt) return ''
  if (props.run.status === 'completed' && props.run.completedAt) {
    return `Completed ${new Date(props.run.completedAt).toLocaleString()}`
  }
  if (props.run.status === 'cancelled' && props.run.cancelledAt) {
    return `Cancelled ${new Date(props.run.cancelledAt).toLocaleString()}`
  }
  if (props.run.status === 'paused' && props.run.pausedAt) {
    return `Paused ${new Date(props.run.pausedAt).toLocaleString()}`
  }
  return `Started ${new Date(props.run.startedAt).toLocaleString()}`
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    class: "workflow-run-panel"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center py-2 px-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: headerIcon.value,
            color: headerColor.value,
            size: "small",
            class: "mr-2"
          }, null, 8, ["icon", "color"]),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-subtitle-1" }, "Factory Run", -1)),
          _createVNode(_component_v_spacer),
          (_ctx.run.status !== 'idle')
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                size: "small",
                density: "compact",
                color: headerColor.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.run.status), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true),
          (_ctx.run.usage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.run.usage.totalTokens || 0) + " total tokens ", 1))
            : _createCommentVNode("", true),
          (_ctx.run.startedAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(statusTimestampLabel.value), 1))
            : _createCommentVNode("", true),
          (_ctx.run.status === 'running')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 3,
                size: "small",
                density: "compact",
                variant: "tonal",
                color: "warning",
                class: "ml-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pause')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-pause",
                    size: "small",
                    class: "mr-1"
                  }),
                  _cache[3] || (_cache[3] = _createTextVNode(" Pause "))
                ]),
                _: 1,
                __: [3]
              }))
            : _createCommentVNode("", true),
          (_ctx.run.status === 'paused')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 4,
                size: "small",
                density: "compact",
                variant: "tonal",
                color: "primary",
                class: "ml-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('resume')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-play",
                    size: "small",
                    class: "mr-1"
                  }),
                  _cache[4] || (_cache[4] = _createTextVNode(" Resume "))
                ]),
                _: 1,
                __: [4]
              }))
            : _createCommentVNode("", true),
          (_ctx.run.status === 'running' || _ctx.run.status === 'paused')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 5,
                size: "small",
                density: "compact",
                variant: "tonal",
                color: "error",
                class: "ml-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-stop",
                    size: "small",
                    class: "mr-1"
                  }),
                  _cache[5] || (_cache[5] = _createTextVNode(" Stop "))
                ]),
                _: 1,
                __: [5]
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1,
        __: [6]
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_text, { class: "pa-3 workflow-run-content" }, {
        default: _withCtx(() => [
          (_ctx.run.stepRuns.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, "Steps (" + _toDisplayString(_ctx.run.stepRuns.length) + ")", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.run.stepRuns, (stepRun) => {
                  return (_openBlock(), _createBlock(FactoryStepRunCard, {
                    key: stepRun.stepRunId,
                    "step-run": stepRun,
                    onOpenWorkflow: openWorkflowRun,
                    onOpenChat: openChatSession
                  }, null, 8, ["step-run"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.run.status === 'completed' && _ctx.run.carryPayload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex align-center justify-space-between mb-2" }, [
                  _createElementVNode("p", { class: "text-overline mb-0" }, "Final Output")
                ], -1)),
                _createVNode(_component_v_card, {
                  variant: "outlined",
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(FormattingCard, {
                      content: _ctx.run.carryPayload,
                      expanded: 'true',
                      title: null,
                      streaming: false
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.run.error)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 2,
                type: "error",
                density: "compact",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.run.error), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.run.status === 'idle')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-play-circle-outline",
                  size: "48",
                  color: "grey"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-2" }, "Click \"Run Factory\" to execute", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})